import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetLocationsList = () =>
  useMutation({
    mutationFn: (data) => client(`resources/sites/${data}`),
  });

export const useGetCountries = () =>
  useMutation({
    mutationFn: () => client("lookups/countries"),
  });
export const useAddLocation = () =>
  useMutation({
    mutationFn: (data) =>
      client("resources/sites/add", {
        data,
        successMessage: "Service point added successfully",
      }),
  });
export const useEditLocation = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/sites/edit`, {
        data,
        successMessage: "Service point updated successfully",
      }),
  });
export const useGetLocation = () =>
  useMutation({
    mutationFn: (locationId) => client(`resources/sites/${locationId}`),
  });
